<!-- order-table.component.html -->
<div class="table-responsive">
  <h2>Bestellübersicht</h2>
<table mat-table [dataSource]="orders" class="mat-elevation-z8">
  <!-- Columns for Order interface -->
  <ng-container matColumnDef="tableNumber">
    <th mat-header-cell *matHeaderCellDef>Tischnummer</th>
    <td mat-cell *matCellDef="let order">{{ order.tableNumber }}</td>
  </ng-container>

  <ng-container matColumnDef="orderNo">
    <th mat-header-cell *matHeaderCellDef>Bestellnummer</th>
    <td mat-cell *matCellDef="let order">{{ order.orderNo }}</td>
  </ng-container>

  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef>Summe</th>
    <td mat-cell *matCellDef="let order">{{ order.total | currency: 'EUR': 'symbol' }}</td>
  </ng-container>

  <ng-container matColumnDef="waiterName">
    <th mat-header-cell *matHeaderCellDef>Kellner</th>
    <td mat-cell *matCellDef="let order">{{ order.waiterName }}</td>
  </ng-container>

  <ng-container matColumnDef="comments">
    <th mat-header-cell *matHeaderCellDef>Kommentar</th>
    <td mat-cell *matCellDef="let order">{{ order.comments }}</td>
  </ng-container>

  <ng-container matColumnDef="createdBy">
    <th mat-header-cell *matHeaderCellDef>Erstellt von</th>
    <td mat-cell *matCellDef="let order">{{ order.createdBy }}</td>
  </ng-container>

  <ng-container matColumnDef="created">
    <th mat-header-cell *matHeaderCellDef>Erstellt am</th>
    <td mat-cell *matCellDef="let order">{{ order.created }}</td>
  </ng-container>

  <ng-container matColumnDef="details">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let order">
      <button mat-icon-button (click)="showOrderDetails(order.positions)">
        <mat-icon>info</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="printAgain">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let order">
      <button mat-icon-button (click)="printOrderAgain(order)">
        <mat-icon>print</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Define the displayed columns order -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let order; columns: displayedColumns;"></tr>
</table>
</div>
